import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { UserDataService } from "src/app/providers/userData/user-data.service";
import { NAACMetricPage } from "../../naacmetric/naacmetric.page";
import { ModalController } from "@ionic/angular";
import { ESupportPage } from "../esupport.page";
import { EsupportQlmPage } from "../esupport-qlm/esupport-qlm.page";
import { AttachmentService } from "src/app/providers/forms/attachment/attachment.service";
import { YearCollegeTypeMappingService } from "src/app/providers/yearCollegeMapping/year-college-type-mapping.service";
import { Constants } from "src/app/util/constants";

@Component({
  selector: "app-esupport-section",
  standalone: false,
  templateUrl: "./esupport-section.component.html",
  styleUrls: ["./esupport-section.component.scss"],
})
export class EsupportSectionComponent implements OnInit {
  @Input() eSupportMapping;
  @Input() nackmetricNumberList;
  @Input() formId;
  @Input() formTypeId;
  @Input() form;

  @Output() metricNumbersEmitter: EventEmitter<string> =
    new EventEmitter<string>();

  sectionOpen = false;
  showQnM: boolean = false;
  showQnMSuggested: boolean = false;
  showQlM: boolean = false;
  showQlMSuggested: boolean = false;
  isFROMIQACDASHBOARD: boolean = false;
  isIQACADMIN: boolean = false;
  isFROM_CRITERIA_DASHBOARD: boolean = false;
  isCRITERIA_COORDINATORS: boolean = false;
  selectedNaccMetricNumber = [];
  showSuggested: boolean = true;
  showOther: boolean = false;
  profile: any = {};
  subscriptionStatus: boolean = true;
  constructor(
    public userdataService: UserDataService,
    public modalController: ModalController,
    public modal: ModalController,
    public collegeTypeYearMappingService: YearCollegeTypeMappingService,
    public attachmentService: AttachmentService
  ) {}

  ngOnInit() {
    this.getProfile();
    this.checkLoggedInUserRole();
    setTimeout(() => {
      this.readESupportMetricMapping();
    }, 1000);
    this.userdataService.getCurrentActiveSection().then((section) => {
      if (section) {
        if (section === "IQAC_DASHBORAD") {
          this.isFROMIQACDASHBOARD = true;
        } else {
          this.isFROMIQACDASHBOARD = false;
        }
        if (section == "CRITERIA_DASHBORAD") {
          this.isFROM_CRITERIA_DASHBOARD = true;
        } else {
          this.isFROM_CRITERIA_DASHBOARD = false;
        }
      }
    });
    // if(this.eSupportMapping.PG == undefined ){
    //   this.eSupportMapping.PG = []
    // }
    // if(this.eSupportMapping.UG == undefined){
    //   this.eSupportMapping.UG = []
    // }
    // if(this.eSupportMapping.AU == undefined){
    //   this.eSupportMapping.AU = []
    // }
    // if(this.eSupportMapping.qlm != undefined || this.eSupportMapping.qlm !=null){
    //   if(this.eSupportMapping.qlm.PG == undefined){
    //     this.eSupportMapping.qlm.PG = []
    //   }
    //   if(this.eSupportMapping.qlm.UG == undefined){
    //     this.eSupportMapping.qlm.UG = []
    //   }
    //   if(this.eSupportMapping.qlm.AU == undefined){
    //     this.eSupportMapping.qlm.AU = []
    //   }
    // }
  }

  readESupportMetricMapping() {
    let _this = this;
    this.userdataService.getToken().then((token) => {
      if (token) {
        this.userdataService.getMetricdata().then((mappings) => {
          if (mappings) {
            mappings.forEach((maping) => {
              if (this.formTypeId == maping.formType) {
                this.eSupportMapping = maping;
              }
            });
            this.showSuggested = true;
            this.checkMetricsToShow();
          }
        });
      }
    });
  }

  metricSegmentChanged(ev: any) {
    if (ev.target.value == "OTHER") {
      this.showSuggested = false;
      this.showOther = true;
    } else {
      this.showSuggested = true;
      this.showOther = false;
    }
    this.checkMetricsToShow();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["form"] &&
      changes["form"].currentValue &&
      changes["form"].currentValue.yearFrom &&
      !changes["form"].currentValue.collegeType
    ) {
      this.userdataService.getUserProfile().then((profile) => {
        if (profile) {
          this.userdataService.getToken().then((token) => {
            this.collegeTypeYearMappingService
              .fetchCollegeTypeYearMapping(token, {
                collegeId: profile.college.id,
              })
              .subscribe(
                (response) => {
                  let yearToCollegeMapping = response.mappings
                    ? response.mappings.sort(Constants.YearFromComparator)
                    : [];
                  yearToCollegeMapping.forEach((mapping) => {
                    if (
                      mapping.yearFrom == changes["form"].currentValue.yearFrom
                    ) {
                      this.form.collegeType = mapping.collegeType;
                      this.checkMetricsToShow();
                    }
                  });
                },
                (error) => {
                  console.log(error);
                }
              );
          });
        }
      });
    }
  }

  checkMetricsToShow() {
    if (
      this.eSupportMapping.PG ||
      this.eSupportMapping.UG ||
      this.eSupportMapping.AU ||
      this.eSupportMapping.CU ||
      this.eSupportMapping.AC
    ) {
      if (
        this.eSupportMapping.PG.length > 0 ||
        this.eSupportMapping.UG.length > 0 ||
        this.eSupportMapping.AU.length > 0 ||
        this.eSupportMapping.CU.length > 0 ||
        this.eSupportMapping.AC.length > 0
      ) {
        this.showQnM = true;
        if (this.form.collegeType) {
          if (
            this.form.collegeType == "UG" &&
            this.eSupportMapping.UG &&
            this.eSupportMapping.UG.length > 0
          ) {
            this.showQnMSuggested = true;
          }
          if (
            this.form.collegeType == "PG" &&
            this.eSupportMapping.PG &&
            this.eSupportMapping.PG.length > 0
          ) {
            this.showQnMSuggested = true;
          }
          if (
            this.form.collegeType == "AU" &&
            this.eSupportMapping.AU &&
            this.eSupportMapping.AU.length > 0
          ) {
            this.showQnMSuggested = true;
          }
          if (
            this.form.collegeType == "CU" &&
            this.eSupportMapping.CU &&
            this.eSupportMapping.CU.length > 0
          ) {
            this.showQnMSuggested = true;
          }
          if (
            this.form.collegeType == "AC" &&
            this.eSupportMapping.AC &&
            this.eSupportMapping.AC.length > 0
          ) {
            this.showQnMSuggested = true;
          }
        }
      }
    }
    if (
      this.eSupportMapping.qlm != undefined ||
      this.eSupportMapping.qlm != null
    ) {
      if (
        this.eSupportMapping.qlm.PG.length > 0 ||
        this.eSupportMapping.qlm.UG.length > 0 ||
        this.eSupportMapping.qlm.AU.length > 0 ||
        this.eSupportMapping.qlm.CU.length > 0 ||
        this.eSupportMapping.qlm.AC.length > 0
      ) {
        this.showQlM = true;
        if (this.form.collegeType) {
          if (
            this.form.collegeType == "UG" &&
            this.eSupportMapping?.qlm?.UG.length > 0
          ) {
            this.showQlMSuggested = true;
          }
          if (
            this.form.collegeType == "PG" &&
            this.eSupportMapping?.qlm?.PG.length > 0
          ) {
            this.showQlMSuggested = true;
          }
          if (
            this.form.collegeType == "AU" &&
            this.eSupportMapping?.qlm?.AU.length > 0
          ) {
            this.showQlMSuggested = true;
          }
          if (
            this.form.collegeType == "CU" &&
            this.eSupportMapping?.qlm?.CU.length > 0
          ) {
            this.showQlMSuggested = true;
          }
          if (
            this.form.collegeType == "AC" &&
            this.eSupportMapping?.qlm?.AC.length > 0
          ) {
            this.showQlMSuggested = true;
          }
        }
      }
    }
  }

  checkLoggedInUserRole() {
    this.userdataService.getLoggedInUserRole().then((roles) => {
      if (roles) {
        let userRoles = [];
        userRoles = roles;
        if (userRoles.includes("IQAC_ADMIN")) {
          this.isIQACADMIN = true;
        } else {
          this.isIQACADMIN = false;
        }
        if (userRoles.includes("CRITERIA_COORDINATOR")) {
          this.isCRITERIA_COORDINATORS = true;
        } else {
          this.isCRITERIA_COORDINATORS = false;
        }
      } else {
        this.isIQACADMIN = false;
      }
    });
  }

  async openNaacMetricPage() {
    if (!this.nackmetricNumberList) {
      this.nackmetricNumberList = [];
    }
    if (this.nackmetricNumberList.length > 0) {
      // let metricObj ={
      //   "key":"",
      //   "value":""
      // }
      this.nackmetricNumberList.forEach((number) => {
        // if(number==="NA" || number === "Undecided"){
        // metricObj.key = number;
        // metricObj.value = number;
        // }else {
        //   metricObj.key = number;
        //   metricObj.value = "Criterion"+ " " + number;
        // }
        this.selectedNaccMetricNumber.push(number);
      });
    }
    const modal = await this.modalController.create({
      component: NAACMetricPage,
      componentProps: {
        formId: this.formId,
        selectedMetrics: this.selectedNaccMetricNumber,
        eSupportMapping: this.eSupportMapping,
        form: this.form,
      },
      backdropDismiss: false,
    });
    /* const modalState = {
      modal : true,
      desc : 'dummy state modal'
    };
    history.pushState(modalState, null); */
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data && data.role && data.role == "applied") {
        const incomingNumbers = data.data;
        this.selectedNaccMetricNumber = [...new Set(incomingNumbers)];

        let stringArrayOfMetricValue = [];
        this.selectedNaccMetricNumber.forEach((number) => {
          stringArrayOfMetricValue.push(number);
        });
        let metricNumbers = "" + stringArrayOfMetricValue;
        if (data.data.length === 0) {
          this.metricNumbersEmitter.emit("");
          this.nackmetricNumberList = [];
          console.log("no number selected");
        } else {
          this.nackmetricNumberList = stringArrayOfMetricValue;
          this.metricNumbersEmitter.emit(metricNumbers);
          // console.log(metricNumbers,"metricnumber");
        }
      }

      // this.pageSpecificFormObject.metricNumbers = "" + metricNumbers;
    });
  }

  async openEsupport(metricId, institution) {
    const modal = await this.modalController.create({
      component: ESupportPage,
      componentProps: {
        metricId: metricId,
        institution: institution,
      },
      backdropDismiss: false,
    });
    modal.present();
  }

  async openQlMEsupport(metricId, institution) {
    const modal = await this.modalController.create({
      component: EsupportQlmPage,
      componentProps: {
        metricId: metricId,
        institution: institution,
      },
      backdropDismiss: false,
    });
    modal.present();
  }

  getProfile() {
    this.userdataService.getUserProfile().then((profile) => {
      if (profile) {
        this.profile = profile;
        if (this.profile.college.status == "SUBS_EXPIRED") {
          this.subscriptionStatus = false;
        }
      }
    });
  }
}
